export const __DEV__ = process.env.NODE_ENV !== "production";
export const API =
  process.env.REACT_APP_API_URL || "https://castle-api.eyetracking.com/v1";
